import { render } from "./Home.vue?vue&type=template&id=6d7c4728"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=6d7c4728&lang=css"
script.render = render

export default script